import React from 'react';
import { getCurrentUser } from 'client/user';
import { State } from './types';

const { useEffect, useReducer } = React;
const FETCH = 'FETCH';
const RECEIVE_USER = 'RECEIVE_USER';
const FETCH_USER_FAILED = 'FETCH_USER_FAILED';
const RESET = 'RESET';

const initialState: State = {
  userId: null,
  webStationId: null,
  currentWebStationId: null,
  status: 'idle',
  imageUrl: null,
};

type Action =
  | { type: typeof FETCH }
  | { type: typeof RECEIVE_USER; payload: CurrentUserResponse }
  | { type: typeof RESET }
  | { type: typeof FETCH_USER_FAILED; error: string };

const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case FETCH:
      return { ...state, status: 'loading', error: undefined };
    case RECEIVE_USER: {
      // if we have user data, set that into state
      if (action.payload && action.payload.user) {
        const {
          payload: {
            user: {
              userId,
              stationId: webStationId,
              currentWebStationId,
              name,
              imageUrl,
            },
          },
        } = action;
        return {
          ...state,
          userId,
          webStationId,
          currentWebStationId,
          name,
          imageUrl,
          status: 'success',
        };
      }
      return { ...state, status: 'success' };
    }
    case FETCH_USER_FAILED:
      return {
        ...state,
        error: action.error,
        status: 'error',
      };
    case RESET:
      return initialState;
    default:
      return state;
  }
};

type CurrentUserResponse = {
  user?: {
    imageUrl: string | null;
    name: string;
    networkRoleUserId: number;
    stationId: string;
    currentWebStationId: string;
    userId: number;
  };
};

const useCurrentUser = () => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const fetchCurrentUser = async () => {
    dispatch({ type: FETCH });
    try {
      const currentUserResponse: CurrentUserResponse = await getCurrentUser();
      dispatch({
        type: RECEIVE_USER,
        payload: currentUserResponse,
      });
    } catch (err) {
      const message = err.message ? err.message : '';
      dispatch({
        type: FETCH_USER_FAILED,
        error: `Failed to getCurrentUser ${message}`,
      });
    }
  };

  useEffect(() => {
    fetchCurrentUser();
  }, []);
  function resetCurrentUser() {
    dispatch({ type: RESET });
  }
  return { state, dispatch, fetchCurrentUser, resetCurrentUser };
};

export { useCurrentUser };
